<template>
  <div class="layout">
    <div class="meals">
      <div
        v-for="(meal, idx) in meals"
        :key="idx"
        class="meal-item"
        :style="mealItemHeight"
      >
        <div class="columns is-mobile is-full-height">
          <div class="column is-4 is-paddingless meal-image">
            <meal-image
              class="image is-full-height"
              :src="meal.thumbUrl || meal.imageUrl"
            />
          </div>
          <div class="column is-paddingless">
            <div class="column is-paddingless">
              <div class="meal-body">
                <div class="meal-name">{{ meal.name }}</div>
                <div v-if="meal.allergens.length > 0" class="meal-allergens">
                  {{ $t("Meal Allergens") }}: {{ allergens(meal.allergens) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-mobile price-and-badges">
          <div class="column is-4 is-paddingless" />
          <div class="column is-flex is-paddingless">
            <div class="badges is-flex">
              <span v-for="(mealBadge, idx) in badges(meal.badges)" :key="idx">
                <img class="badge-icon" :src="mealBadge.icon" />
              </span>
            </div>
            <div class="meal-price has-text-right">
              <strong class="price">
                {{ meal.price | money }} {{ currency }}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MealImage from "@/components/meal-image"
import { state } from "@/store"
import { allergenCodes, badgeCodes } from "@/service/meal-constants"
import { slicer } from "@/utils"

export default {
  maxMeals: 3,
  slicer: slicer.fillMinimumMealsPerScreen,
  name: "layout-combined-default",
  props: ["meals"],
  components: { MealImage },
  computed: {
    currency() {
      return state.project.data.currency
    },
    mealItemHeight() {
      return `height: ${98 / this.meals.length}%`
    }
  },
  methods: {
    allergens(allergens) {
      return allergenCodes(allergens)
    },
    badges(badges) {
      return badgeCodes(badges)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.layout {
  background-color: white;
  padding: 0.5em;
}
.meals {
  height: 100%;
  width: 100%;
  font-family: "Arial", serif;
  .meal-item {
    border: 1px solid $meal-item-border-color;
    border-radius: 4px;
    height: 97%;
    padding: 0.5em;
    margin-bottom: 0.5em;
    .meal-body {
      padding-top: 0.1em;
      padding-left: 0.25em;
      font-size: 3.7em;
    }
    .meal-name {
      white-space: pre-wrap;
    }
    .meal-allergens {
      padding-bottom: 0.5em;
      font-size: 0.5em;
      color: gray;
    }
    .price-and-badges {
      position: relative;
      bottom: 7.5em;
      .meal-price {
        position: relative;
        right: 0.5em;
        width: 100%;
        .price {
          padding: 0.3em 0.5em;
          font-size: 4em;
          background-color: orange;
          border-radius: 50%;
        }
      }
      .badges {
        padding: 0 0 0 0.75em;
        .badge-icon {
          position: relative;
          width: 4em;
          padding-top: 3em;
        }
      }
    }
    .columns {
      margin: 0;
    }
  }
}
.is-full-height {
  height: 100%;
}
</style>
